import { OverviewMetrics } from '../types';
import { Activity, CheckCircle, XCircle, Clock, Users } from 'lucide-react';

interface MetricsOverviewProps {
  metrics: OverviewMetrics;
}

export default function MetricsOverview({ metrics }: MetricsOverviewProps) {
  const totalRequests = Number(metrics?.totalRequests) || 0;
  const successRate = Number(metrics?.successRate) || 0;
  const errorRate = Number(metrics?.errorRate) || 0;
  const avgResponseTime = Number(metrics?.avgResponseTime) || 0;
  const activeUsers = Number(metrics?.activeUsers) || 0;

  const cards = [
    {
      title: 'Total de Requisições',
      value: totalRequests.toLocaleString(),
      icon: Activity,
      color: 'text-primary-600',
      bgColor: 'bg-primary-50',
    },
    {
      title: 'Taxa de Sucesso',
      value: `${successRate.toFixed(2)}%`,
      icon: CheckCircle,
      color: 'text-green-600',
      bgColor: 'bg-green-50',
    },
    {
      title: 'Taxa de Erro',
      value: `${errorRate.toFixed(2)}%`,
      icon: XCircle,
      color: 'text-red-600',
      bgColor: 'bg-red-50',
    },
    {
      title: 'Tempo Médio de Resposta',
      value: `${avgResponseTime.toFixed(2)}ms`,
      icon: Clock,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50',
    },
    {
      title: 'Usuários Ativos',
      value: activeUsers.toString(),
      icon: Users,
      color: 'text-purple-600',
      bgColor: 'bg-purple-50',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
      {cards.map((card) => {
        const Icon = card.icon;
        return (
          <div
            key={card.title}
            className={`${card.bgColor} rounded-lg p-6 shadow-sm border border-gray-100`}
          >
            <div className="flex items-center justify-between mb-2">
              <Icon className={`h-6 w-6 ${card.color}`} />
            </div>
            <h3 className="text-sm font-medium text-gray-600 mb-1">{card.title}</h3>
            <p className={`text-2xl font-bold ${card.color}`}>{card.value}</p>
          </div>
        );
      })}
    </div>
  );
}

